export default __webpack_public_path__ + "static/media/soldby.5c97f0d1.svg";